import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Carregando...</div>;
  }

  // Perfil ADMIN = 1
  return user && user.perfil_id === 1 ? children : <Navigate to="/dashboard" />;
};

export default AdminRoute;